import Geo from './geo.js';
import Param from './param.js';
import Cookie from './cookie.js';
import LocalStorage from './local-storage';
import Utils from "./utils";

/**
 * class Module
 * Combines all the visibility conditions
 */
class Module {

	/**
	 * init
	 */
	init() {

		document.querySelectorAll( '[' + Utils.dataSelector + ']' ).forEach( element => {

			const elementData = Utils.getData( element );
			const isAllHideElement = 'yes' === Utils.isAllHide( element );
			let showAllHideElement = { show: true };

			new Geo().handleGeoConditions( element, elementData, isAllHideElement, showAllHideElement );
			new Param().handleParamVisibility( element, elementData, isAllHideElement, showAllHideElement );
			new Cookie().handleCookieVisibility( element, elementData, isAllHideElement, showAllHideElement );
			new LocalStorage().handleLocalStorageVisibility( element, elementData, isAllHideElement, showAllHideElement );

			if ( isAllHideElement && showAllHideElement.show ) {
				element.classList.remove( Utils.hideClass );
			}

		} );

	}

}

new Module().init();
